var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.name)?_c('span',{staticClass:"material-icon",style:({ fontSize: ((_vm.props.size || 24) + "px") })},[_vm._v("\n  "+_vm._s(_vm.props.name)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }